import React, { useState } from 'react';
import Button from '../../../components/Button';
import InputCell from '../../../components/InputCell';
import { validatePassword } from '../../../scripts/formValidator';
import { _createUserWithEmailAndPassword } from '../../../redux/actions';
var SignupForm = function (props) {
    var _a = useState(props.email), email = _a[0], setEmail = _a[1];
    var _b = useState(''), password = _b[0], setPassword = _b[1];
    var _c = useState(''), confirmPassword = _c[0], setConfirmPassword = _c[1];
    var _d = useState(false), displayValidation = _d[0], setDisplayValidation = _d[1];
    return (React.createElement("div", { className: 'm-4 flex w-full max-w-xs flex-col items-center gap-3' },
        React.createElement("h3", { className: 'mb-4' }, "Create an account"),
        React.createElement("form", { className: 'flex w-full max-w-xs flex-col gap-3 text-center' },
            React.createElement(InputCell, { type: 'email', placeholder: 'Email', value: email, onChange: setEmail, id: 'email' }),
            React.createElement(InputCell, { placeholder: 'Choose a password', type: 'password', value: password, onChange: setPassword, displayError: displayValidation && !validatePassword(password), errorMessage: 'Password not valid.', id: 'password' }),
            React.createElement(InputCell, { type: 'password', placeholder: 'Repeat password', value: confirmPassword, onChange: setConfirmPassword, displayError: displayValidation && password !== confirmPassword, errorMessage: "Passwords don't match.", description: 'Password must have 8+ characters and at least one number.', id: 'repeat-password' }),
            React.createElement(Button, { label: 'Create account', onClick: function () {
                    if (validatePassword(password) && password === confirmPassword) {
                        _createUserWithEmailAndPassword(email, password);
                    }
                    else {
                        setDisplayValidation(true);
                    }
                }, id: 'signup' }))));
};
export default SignupForm;
